export enum LocationSource {
    mobile = "mobile",
    web = "web",
}

export interface ILocationDto {
    latitude: number
    longitude: number
}

export default class Location {
    lat: number
    lng: number

    constructor(dto: ILocationDto) {
        this.lat = dto.latitude
        this.lng = dto.longitude
    }

    toDto(): ILocationDto {
        return {
            latitude: this.lat,
            longitude: this.lng
        }
    }
}
